import { Menu } from '@base-ui-components/react/menu'
import { cn } from '../../utils/cn'

export function MenuItem({ className, inset, ...props }: MenuItem.Props) {
  return (
    <Menu.Item
      className={cn(
        'relative flex cursor-default select-none items-center gap-2 px-3.5 py-1.5 text-sm outline-none [&>svg]:size-4 [&>svg]:shrink-0',
        'select-none data-[highlighted]:relative data-[highlighted]:z-0 data-[highlighted]:before:absolute data-[highlighted]:before:inset-x-1 data-[highlighted]:before:inset-y-0 data-[highlighted]:before:z-[-1] data-[highlighted]:before:rounded-md data-[highlighted]:before:bg-gray-100',
        inset && 'pl-8',
        className
      )}
      {...props}
    />
  )
}

export namespace MenuItem {
  export interface Props extends Menu.Item.Props {
    inset?: boolean
  }
}
